module.exports = __webpack_public_path__ + "assets/mobx.6f7a2916.svg";